// 囤货到日本国际物流展示
export const STOCK_JP_SHIPPING = 1
// 日本商品采购权限
export const JP_GOODS_PURCHASE = 2

// 日本商品采购权限(有TIKTOK)
export const JP_GOODS_PURCHASE_HAS_TIKTOK = 3